import UserStatistics from './user-statistics.list';

export default {
  list: UserStatistics,
};
